import {Connection} from '@flowmaps-com/flowmaps-typescriptmodels';

export function selectUploadConnections<T extends { connection?: Connection }>(
    connections: T[], selectedIds: string[]): T[] {
    const selected = connections.filter(entity =>
        !!entity.connection && (!selectedIds.length || selectedIds.includes(entity.connection.connectionId)));
    const codes = selected.map(entity => entity.connection.info.code);
    if (new Set(codes).size !== codes.length) {
        throw new Error('Select one connection when multiple connections have the same code');
    }
    return selected;
}
